var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNearWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    fill: "#0F0F0F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6196 5.61425L12.1132 9.33387C11.9399 9.58718 12.2732 9.89381 12.5131 9.6805L14.9795 7.53405C15.0462 7.48072 15.1395 7.52072 15.1395 7.61404V14.32C15.1395 14.4134 15.0195 14.4533 14.9662 14.3867L7.50031 5.45426C7.26033 5.16096 6.9137 5.00098 6.52707 5.00098H6.26043C5.56717 5.00098 4.9939 5.57425 4.9939 6.28085V15.7199C4.9939 16.4265 5.56717 16.9998 6.27377 16.9998C6.71372 16.9998 7.12701 16.7731 7.36699 16.3865L9.8734 12.6669C10.0467 12.4136 9.71342 12.1069 9.47344 12.3202L7.00702 14.4533C6.94036 14.5067 6.84704 14.4667 6.84704 14.3734V7.6807C6.84704 7.58738 6.96703 7.54738 7.02036 7.61404L14.4863 16.5465C14.7262 16.8398 15.0862 16.9998 15.4595 16.9998H15.7261C16.4327 16.9998 17.006 16.4265 17.006 15.7199V6.28085C16.9927 5.57425 16.4194 5.00098 15.7128 5.00098C15.2728 5.00098 14.8596 5.22762 14.6196 5.61425Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNearWallet);
export default __webpack_public_path__ + "static/media/NearWallet.c820f8b04e41ee8b60e10dd705ad0881.svg";
export { ForwardRef as ReactComponent };